import { VariableValue } from '@components/Variables/types'

import { ObjectFieldDTO } from '@types'

import { getObjectXColumnExamples } from './getObjectXColumnExamples'

export const getColumnScriptConfig = (data: {
  variables: VariableValue[]
  objectYFields: ObjectFieldDTO[]
  objectXFields: ObjectFieldDTO[]
}) => {
  const { variables, objectYFields } = data

  return {
    examples: getObjectXColumnExamples(),
    variables: [
      {
        name: 'srcObj',
        type: [
          {
            name: 'yElement',
            type: !objectYFields?.length
              ? 'any'
              : objectYFields.map(field => {
                  return {
                    name: field.name,
                    type: field.valueType,
                  }
                }),
          },
          { name: 'startDate', type: 'string' },
          { name: 'endDate', type: 'string' },
          { name: 'id', type: 'string' },
          { name: 'groupId', type: 'string' },
          { name: 'objectYTotalCount', type: 'number' },
          {
            name: 'variables',
            type: variables.map(variable => {
              return {
                name: variable.internalId,
                type: [
                  { name: 'defaultValue', type: 'any', description: '' },
                  { name: 'valueType', type: 'string', description: '' },
                  { name: 'variableType', type: 'string', description: '' },
                  { name: 'entityType', type: 'string', description: '' },
                ],
              }
            }),
            description: 'Current total count',
          },
        ],
      },
    ],
    fieldsInfo: [
      ...variables.map(item => {
        return { key: `srcObj.variables.${item.internalId}`, name: '', objectCode: 'context' }
      }),
      {
        key: 'srcObj.startDate',
        objectCode: 'context',
      },
      {
        key: 'srcObj.endDate',
        objectCode: 'context',
      },
      { key: 'srcObj.id', objectCode: 'context' },
      { key: 'srcObj.groupId', objectCode: 'context' },
      { key: 'srcObj.yElement', objectCode: 'context' },
      { key: 'srcObj[column_key]', objectCode: 'context' },
      { key: 'srcObj.objectYTotalCount', objectCode: 'context' },
    ],
  }
}
